<template>
  <div
    class="row"
  >
    <picture>
      <source
      srcset="../../assets/imgs/TT-tiny-img/TT_logo.png, ../../assets/imgs/TT-tiny-img/TT_logo@2x.png 2x, ../../assets/imgs/TT-tiny-img/TT_logo@3x.png 3x"
      media="(min-width: 576px)"
      class="logo"
      >
      <source
      srcset="../../assets/imgs/TT-tiny-img/TT_logo-small.png, ../../assets/imgs/TT-tiny-img/TT_logo-small@2x.png 2x, ../../assets/imgs/TT-tiny-img/TT_logo-small@3x.png 3x"
      media="(max-width: 576px)"
      class="logo"
      >
      <img
      src="../../assets/imgs/TT-tiny-img/TT_logo.png"
      alt="My default image"
      class="logo"
      >
    </picture>
    <TCSelector/>
    <button
      :class="['btn_menu', aside_visible? 'btn_menu-close': 'btn_menu-normal']"
      @click="aside_toggle"
    >
      <div :class="['btn_menu-bar', aside_visible? 'btn_menu-bar-close': 'btn_menu-bar-normal']"></div>
    </button>
    <Map/>
    <ProbabilityChart/>
    <transition name="aside_fade">
      <div
        class="aside-container"
        v-show="aside_visible"
      >
        <Aside/>
      </div>
    </transition>

    <div class="play_dtg_container"
         :class="{ play_dtg_button_upper: footer_visible}">
      <button
        id="play-dtg"
        class="play_dtg_button"
        @click="looping = !looping"
      >
        <div
          :class="[looping ? 'play_dtg_stop' : 'play_dtg_start' ]"
        >
        </div>
      </button>
    </div>
    <div
      class='time_slider_container'
      :class="{ time_slider_upper: footer_visible}"
    >
      <TimeSlideBar ref="TimeSlideBar"
        :inittime="timebar_init"
        @time_slider_callback="time_slider_callback"
      >
      </TimeSlideBar>
    </div>

    <button
      class="footer-toggle"
      :class="{ footer_toggle_active: footer_visible}"
      @click="footer_toggle"
    >
      <div
        :class="[footer_visible ? 'footer_collapse' : 'footer_expend' ]"
      ></div>
    </button>

    <transition name="footer_fade">
      <div
        class="footer-container"
        v-show="footer_visible"
      >
        <Footer/>
      </div>
    </transition>

  </div>
</template>

<script>
import Map from '@/components/typhoon_tw/Map'
import Aside from '@/components/typhoon_tw/Aside'
import TimeSlideBar from '@/components/TimeSlideBar'
import Footer from '@/components/typhoon_tw/Footer.vue'
import ProbabilityChart from '@/components/typhoon_tw/ProbabilityChart.vue'
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'
const Tortoise = require('@/assets/js/cb').Tortoise
import TCSelector from './TCSelector'

export default {

  data () {
    return {
      aside_visible: false,
      footer_visible: false,
      looping: false,
      aside_close_icon: 'icon-close',
      aside_open_icon: 'icon-menu'
    }
  },

  components: {
    TCSelector,
    ProbabilityChart,
    'Map': Map,
    'Aside': Aside,
    'TimeSlideBar': TimeSlideBar,
    'Footer': Footer
  },

  methods: {
    ...mapActions({
      initialize: types.INITIALIZE,
      set_dtg: types.SET_DTG,
      set_stop_dtg: types.SET_STOP_DTG
    }),

    time_slider_callback (val, is_moving) {
      let self = this

      if (!is_moving) {
        if (!self.tortoise_stop_dtg) {
          let _set_dtg = function (new_dtg) {
            let _dt = new Date(new_dtg)
            if (!isNaN(_dt)) {
              self.set_stop_dtg(_dt.dtgftime())
            }
          }
          self.tortoise_stop_dtg = new Tortoise(_set_dtg, {
            delay: 2000
          })
        }
        self.tortoise_stop_dtg.punch(val)
      }

      if (!self.tortoise_dtg) {
        let _set_dtg = function (new_dtg) {
          let _dt = new Date(new_dtg)
          if (!isNaN(_dt)) {
            self.set_dtg(_dt.dtgftime())
          }
        }

        self.tortoise_dtg = new Tortoise(_set_dtg, {
          delay: 20
        })
      }
      self.tortoise_dtg.punch(val)
    },

    aside_toggle () {
      this.aside_visible = !this.aside_visible
      return this.aside_visible
    },

    footer_toggle () {
      this.footer_visible = !this.footer_visible
      return this.footer_visible
    }
  },

  computed: {
    ...mapGetters({
      get_options: types.GET_OPTIONS,
      get_dtg: types.GET_DTG
    }),

    timebar_dtg () {
      return this.get_dtg
    },

    timebar_init () {
      return this.get_options.selected_init_time_z
    }
  },

  watch: {
    timebar_dtg() {
      let _dtg = this.get_dtg
      this.$refs.TimeSlideBar.set_selected_time(_dtg)
    }
  },

  mounted () {
    let dtg = this.$route.query.dtg
    this.initialize(dtg)

    let self = this
    setTimeout(function loop () {
      if (self.looping && self.$refs.TimeSlideBar) {
        self.$refs.TimeSlideBar.next()
      }
      setTimeout(loop, 800)
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/typhoon_tw/Main.vue